import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProviderWithNavigate } from 'auth-provider-with-navigate';
import { AxiosError } from 'axios';
import { InsufficientBalance } from 'components/insufficientBalance';
import { PropsWithChildren, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider as JotaiProvider } from 'jotai';
import { PlanLimitModal } from 'components/planLimitModal';

declare module '@tanstack/react-query' {
    interface Register {
        defaultError: AxiosError;
    }
}
export const AppProviders = ({ children }: PropsWithChildren) => {
    const [isInsufficientBalanceOpen, setIsInsufficientBalanceOpen] =
        useState(false);
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
            },
            mutations: {
                onError: (error) => {
                    if ((error as any).status === 402) {
                        setIsInsufficientBalanceOpen(true);
                    }
                },
            },
        },
    });
    return (
        <QueryClientProvider client={queryClient}>
            <JotaiProvider>
                <BrowserRouter>
                    <AuthProviderWithNavigate>
                        {children}
                        <InsufficientBalance
                            isOpen={isInsufficientBalanceOpen}
                            setIsOpen={setIsInsufficientBalanceOpen}
                        />
                        <PlanLimitModal />
                    </AuthProviderWithNavigate>
                </BrowserRouter>
            </JotaiProvider>
        </QueryClientProvider>
    );
};
